(function () {
  var BOOKING_URL =
    "https://calendar.google.com/calendar/appointments/schedules/AcZssZ0Ycv72GZ4Po5o10_1KGa2QYkaNBd58DAiZow_kdetN_NwgKHtmlNaCerz7Vy3CxgITSZtx-Za3?gv=true";

  var GOOGLE_SCRIPT_URL =
    "https://calendar.google.com/calendar/scheduling-button-script.js";

  var GOOGLE_CSS_URL =
    "https://calendar.google.com/calendar/scheduling-button-script.css";

  var googleButtonPromise = null;

  /**
   * Charge le CSS Google une seule fois.
   */
  function loadGoogleStyles() {
    if (
      !document.querySelector(
        'link[href*="calendar/scheduling-button-script.css"]'
      )
    ) {
      var link = document.createElement("link");

      link.rel = "stylesheet";
      link.href = GOOGLE_CSS_URL;

      document.head.appendChild(link);
    }

    /**
     * Cache uniquement le véritable bouton Google.
     * La fenêtre popup reste visible lorsqu’elle s’ouvre.
     */
    if (!document.getElementById("google-calendar-hidden-style")) {
  var style = document.createElement("style");

  style.id = "google-calendar-hidden-style";

  style.textContent = `
    /* Cache le bouton Google utilisé pour déclencher la popup */
    #google-calendar-popup-target + .qxCTlb {
      position: fixed !important;
      left: -9999px !important;
      top: -9999px !important;
      opacity: 0 !important;
      pointer-events: none !important;
    }

    /* Élargit la popup Google sur mobile */
    @media screen and (max-width: 749px) {
      .hur54b{
        padding: 20px !important;
      }
    }
  `;

  document.head.appendChild(style);
}
  }

  /**
   * Charge le script Google une seule fois.
   */
  function loadGoogleScript() {
    return new Promise(function (resolve, reject) {
      if (
        window.calendar &&
        window.calendar.schedulingButton
      ) {
        resolve();
        return;
      }

      var existingScript = document.querySelector(
        'script[src*="calendar/scheduling-button-script.js"]'
      );

      if (existingScript) {
        existingScript.addEventListener(
          "load",
          resolve,
          { once: true }
        );

        existingScript.addEventListener(
          "error",
          reject,
          { once: true }
        );

        return;
      }

      var script = document.createElement("script");

      script.src = GOOGLE_SCRIPT_URL;
      script.async = true;

      script.onload = function () {
        if (
          window.calendar &&
          window.calendar.schedulingButton
        ) {
          resolve();
        } else {
          reject(
            new Error("Le module Google Calendar est indisponible.")
          );
        }
      };

      script.onerror = function () {
        reject(
          new Error("Impossible de charger Google Calendar.")
        );
      };

      document.head.appendChild(script);
    });
  }

  /**
   * Crée le point d’insertion du bouton Google invisible.
   */
  function getGoogleTarget() {
    var target = document.getElementById(
      "google-calendar-popup-target"
    );

    if (!target) {
      target = document.createElement("span");
      target.id = "google-calendar-popup-target";
      target.hidden = true;

      document.body.appendChild(target);
    }

    return target;
  }

  /**
   * Récupère le bouton généré par Google.
   */
  function findGoogleButton(target) {
    var button = target.nextElementSibling;

    if (
      button &&
      button.classList.contains("qxCTlb")
    ) {
      return button;
    }

    return null;
  }

  /**
   * Initialise le bouton Google invisible.
   */
  function initializeGoogleButton() {
    if (googleButtonPromise) {
      return googleButtonPromise;
    }

    googleButtonPromise = new Promise(function (resolve, reject) {
      loadGoogleStyles();

      loadGoogleScript()
        .then(function () {
          var target = getGoogleTarget();
          var observer;

          function finishInitialization() {
            var googleButton = findGoogleButton(target);

            if (!googleButton) {
              return false;
            }

            if (observer) {
              observer.disconnect();
            }

            resolve(googleButton);
            return true;
          }

          observer = new MutationObserver(function () {
            finishInitialization();
          });

          observer.observe(document.body, {
            childList: true
          });

          try {
            window.calendar.schedulingButton.load({
              url: BOOKING_URL,
              color: "#1E2A40",
              label: "Réserver un rendez-vous",
              target: target
            });

            finishInitialization();
          } catch (error) {
            observer.disconnect();
            reject(error);
          }
        })
        .catch(reject);
    }).catch(function (error) {
      googleButtonPromise = null;
      throw error;
    });

    return googleButtonPromise;
  }

  /**
   * Intercepte tous les liens Shopify correspondants.
   */
  document.addEventListener("click", function (event) {
    if (!event.target || !event.target.closest) {
      return;
    }

    var trigger = event.target.closest(
      'a[href*="#prendre-rendez-vous"]'
    );

    if (!trigger) {
      return;
    }

    event.preventDefault();

    initializeGoogleButton()
      .then(function (googleButton) {
        googleButton.click();
      })
      .catch(function () {
        /**
         * Sécurité : ouverture directe de la page Google
         * si la popup ne peut pas être chargée.
         */
        window.location.href = BOOKING_URL;
      });
  });

  /**
   * Précharge Google uniquement sur les pages contenant
   * au moins un bouton de réservation.
   */
  if (
    document.querySelector(
      'a[href*="#prendre-rendez-vous"]'
    )
  ) {
    initializeGoogleButton().catch(function () {
      // Le lien direct prendra le relais en cas d’échec.
    });
  }
})();